const points = [
  "La poignée tourne dans le vide : le problème vient souvent du carré d'entraînement ou de la crémone",
  "La poignée est dure : la crémone est bloquée ou un point de serrage est coincé",
  "La poignée est cassée : le plastique est fendu ou la fixation est lâche",
  "La crémone est déformée : elle frotte contre le cadre et doit être réalignée ou changée",
  "Les deux doivent être compatibles : poignée et crémone doivent avoir le même pas et le même axe",
];

export default function HandleOrCremone() {
  return (
    <section className="bg-rose-50 py-10 md:py-14 lg:py-16">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-[1280px] mx-auto mx-auto">
          <p className="font-serif italic text-plum-dark text-sm md:text-base mb-3">
            Le bon diagnostic
          </p>
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-plum mb-6 leading-tight">
            Poignée ou <span className="font-serif italic">crémone</span> : le bon diagnostic
          </h2>
          <p className="text-base md:text-lg text-plum-dark leading-relaxed mb-8">
            Quand une poignée de fenêtre ne fonctionne plus, il faut identifier si le problème vient de la poignée elle-même ou de la crémone. Un mauvais diagnostic conduit à changer la mauvaise pièce. La poignée est le bouton que vous tournez. La crémone est la barre verticale cachée dans le cadre, qui actionne les points de fermeture. Si la poignée tourne dans le vide mais la fenêtre ne bouge pas, c'est probablement la crémone ou le carré d'entraînement. Si la poignée est bloquée ou dure, c'est souvent la crémone qui frotte contre le cadre.
          </p>
          <p className="text-base md:text-lg text-plum-dark leading-relaxed mb-8">
            Nos techniciens à Strasbourg ont le réflexe de vérifier les deux. Nous démontons la poignée, testons le carré d'entraînement, et inspectons la crémone. Si la poignée est cassée mais la crémone est en bon état, nous remplaçons uniquement la poignée. Si les deux sont usés, nous vous proposons le changement des deux pour un résultat durable. Le diagnostic est gratuit et fait chez vous.
          </p>
          <div className="space-y-4">
            {points.map((p, i) => (
              <div key={i} className="flex items-start gap-4 bg-white rounded-2xl border border-rose-200 p-5 md:p-6">
                <div className="w-8 h-8 rounded-full bg-coral/10 flex items-center justify-center shrink-0 mt-0.5">
                  <i className="ri-check-line text-coral text-sm" />
                </div>
                <span className="text-plum-dark font-medium text-sm md:text-base">{p}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}